var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",class:_vm.classes},[(_vm.faIcon)?_c('span',{class:_vm.iconType + _vm.icnClasses}):_vm._e(),_vm._v(" "),_c('div',{style:(_vm.textColor ? `color:var(--${_vm.textColor});` : '')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }